// import img1 from ;
const data = [
  {
    id: 1,
    img: [
      require("../../images/homepage/family-gathering-mobile@2x.jpg").default,
      require("../../images/homepage/family-gathering-tablet@2x.jpg").default,
      require("../../images/homepage/family-gathering-desktop@2x.jpg").default,
    ],

    title: "Family Gathering",
    text: "We love catering for entire families. So please bring everyone along for a special meal with your loved ones. We’ll provide a memorable experience for all.",
  },

  {
    id: 2,
    img: [
      require("../../images/homepage/special-events-mobile@2x.jpg").default,
      require("../../images/homepage/special-events-tablet@2x.jpg").default,
      require("../../images/homepage/special-events-desktop@2x.jpg").default,
    ],

    title: "Special Events",
    text: "Whether it’s a romantic dinner or special date you’re celebrating with others we’ll look after you. We’ll be sure to mark your special date with an unforgettable meal.",
  },

  {
    id: 3,
    img: [
      require("../../images/homepage/social-events-mobile@2x.jpg").default,
      require("../../images/homepage/social-events-tablet@2x.jpg").default,
      require("../../images/homepage/social-events-desktop@2x.jpg").default,
    ],

    title: "Social Events",
    text: "Are you looking to have a larger social event? No problem! We’re more than happy to cater for big parties. We’ll work with you to make your event a hit with everyone.",
  },
];

export default data;
